export default __webpack_public_path__ + "static/media/Circlet of a Thousand Blossoms.00fa59ff.jpg";